import axios from '@axios'

export default {
  namespaced: true,
  state: {
    listaLogs: [],
  },
  mutations: {
    SET_LISTA_LOGS(state, payload) {
      state.listaLogs = payload
    },
  },
  actions: {
    async buscarComFiltros(ctx, { filter, pageConfig }) {
      try {
        const {
          dataInicio, dataFinal, tabela, operacao, userId,
        } = filter

        const urlParams = new URLSearchParams()
        urlParams.append('page', pageConfig.page - 1)
        urlParams.append('size', pageConfig.size)
        urlParams.append('sort', 'dataHora,desc')

        const payload = {
          dataInicio,
          dataFinal,
          tabela,
          operacao,
          userId,
        }

        const response = await axios.post(
          `/adm/logs/filtro?${urlParams.toString()}`,
          payload,
        )
        ctx.commit('SET_LISTA_LOGS', response.data.content || [])
        return response
      } catch (error) {
        throw error
      }
    },
  },
}
